import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const showMobileMenuAtom = atom({
	key: "showMobileMenuAtom",
	default: false,
});
